<script>
  import UnidadePolicialService from '../../../../../domain/policia-civil/unidade-policial/services/unidade-policial'
  import estadosBr from '../../../../_default/utils/estados-brasileiros'
  import {isArray, uniqBy} from 'lodash'
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    components: {},
    nome: 'nova-unidade-policial',
    directives: {mask},
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        loadTiposText: 'Carregando',
        loadPatiosText: 'Carregando',
        data: {
          id: null,
          nome: null,
          matricula: null,
          telefone: null,
          recebedorPatio: false,
          tipoPolicial: null,
          ativo: false,
          patios: null
        },
        tiposPolicial: [],
        patiosArr: []
      }
    },
    computed: {
      estadosBr () {
        return estadosBr
      },
      cidadesFiltered () {
        const cidades = uniqBy(this.listaCidades, item => item.Codigo)
        return cidades.filter(item => item.Codigo !== 0)
      },
      cidadeSelecionada () {
        return this.listaCidades.find(item => item.Codigo === this.data.codigoMunicipioArrematante)
      },
      patios () {
        return this.patiosArr.map(item => {
          if (this.data.patios != null) {
            item.checked = this.data.patios.findIndex(patio => patio.id === item.id) !== -1
          }
          return item
        })
      }
    },
    created () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        this.tipos()
        this.patiosList()
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          UnidadePolicialService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data

              this.ajustaValores()
              console.log(response)
            })
              .catch((response) => {
                this.$loaderOverlay.hide()
                console.log(response)
              })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      tipos () {
        this.tiposPolicial = null
        UnidadePolicialService.tipos().then((response) => {
          this.loadTiposText = 'Selecione'
          console.log('Tipos')
          console.log(response.data.tipos_policial)
          this.tiposPolicial = response.data.tipos_policial
        })
          .catch((response) => {
            this.loadTiposError = true
            this.loadTiposText = 'Erro'
            console.log(response)
          })
      },
      patiosList () {
        UnidadePolicialService.patios().then((response) => {
          this.loadPatiosText = 'Selecione'
          console.log('Patios')
          console.log(response.data.patios)
          this.patiosArr = response.data.patios
        })
          .catch((response) => {
            this.loadTiposError = true
            this.loadTiposText = 'Erro'
            console.log(response)
          })
      },
      ajustaValores (inversed) {
        inversed = inversed || false
        if (inversed) {
          console.log('Inversed fields to data')
        } else {
          this.data.tipoPolicial = (typeof this.data.tipoPolicial['id'] !== 'undefined') ? this.data.tipoPolicial['id'] : this.data.tipoPolicial
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        const data = JSON.parse(JSON.stringify(this.data))

        data.patios = this.patiosArr.filter(item => item.checked).map(item => item.id)
        data.cep = data.cep && data.cep.replace(/\D/g, '')

        UnidadePolicialService.cadastrar(data, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Unidade Policial</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'policiacivil.policia.unidade-policial.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Tipo de policial</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.tipoPolicial">
                    <option disabled value="">{{loadTiposText}}</option>
                    <option v-for="tipoPolicial in tiposPolicial" v-bind:value="tipoPolicial.id">
                      {{ tipoPolicial.nome }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="tipo-impeditiva" class="col-sm-4 control-label">Ativo</label>
                <div class="col-sm-8">
                  <input id="tipo-impeditiva" type="checkbox" v-model="data.ativo"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">CEP</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cep" v-mask="'##.###-###'"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Endereço</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.endereco"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Complemento</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.complemento"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Bairro</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.bairro"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Cidade</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cidade"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">UF</label>
                <div class="col-sm-8">
                  <select required class="form-control" v-model="data.uf">
                    <option :value="null" disabled>Selecione</option>
                    <option :value="estado.sigla" v-for="estado in estadosBr" :key="estado.sigla">{{estado.nome}}</option>
                  </select>
                </div>
              </div>


              <div class="form-group">
                <label class="col-sm-4 control-label">Patios</label>
                <div class="col-sm-8">
                  <div v-for="(patio, patioIndex) in patios" :key="patio.id">
                      <div class="form-group">
                        <div class="col-sm-8">
                          <label class="col-sm-4" :for="`${patio.id}`" >{{ patio.nome }}</label>
                          <input type="checkbox" :id="`${patio.id}`" :value="patio.id" v-model="patio.checked" />
                        </div>
                      </div>
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.policials.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoUnidadePolicial.vue?02f221a4